import { useEffect, useState } from "react";

type TypeOsPlatform = "windows" | "mac" | "linux" | "" | undefined;
const usePlatform = () => {
  const os = {
    windows: /Windows/i,
    mac: /Mac/i,
    linux: /Linux/i,
  };
  const [platform, setPlatform] = useState<TypeOsPlatform>();
  useEffect(() => {
    const browser = typeof window !== undefined;
    let result: TypeOsPlatform;

    if (browser) {
      if (navigator?.userAgent?.match(os.windows)) {
        result = "windows";
      } else if (navigator?.userAgent?.match(os.mac)) {
        result = "mac";
      } else if (navigator?.userAgent?.match(os.linux)) {
        result = "linux";
      } else {
        result = "";
      }

      setPlatform(result);
    }
  }, []);

  return platform;
};

export default usePlatform;
